const store = {
    namespaced: true,
    state() {
        return {
            shops: []
        }
    },
    getters: {
        getShopsLocations: (state) => state.shops
    },
    mutations: {
        SET_SHOPS_LOCATIONS(state, shops) {
            state.shops = shops
        },
    },
    actions: {
        fetchShopsLocations: async function ({ commit }, data)  {
            try {
                const { data } = await this.$api.home.getShopsLocations()

                commit('SET_SHOPS_LOCATIONS', data)
            } catch (e) {
                console.error(e)
            }
        }
    }
}

export default store